import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import EmployeesOverview from "@components/widgets/employees/overview/EmployeesOverview";

const Employees = () => {
    const route: Route = useMemo(() => router.employees, []);

    return (
        <AdminLayout currentPage={route}>
            <EmployeesOverview/>
        </AdminLayout>
    );
};

export default Employees;